/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

export function SearchIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5999 10.4C16.5999 13.8242 13.8241 16.6 10.4 16.6C6.97579 16.6 4.19995 13.8242 4.19995 10.4C4.19995 6.97585 6.97579 4.20001 10.4 4.20001C13.8241 4.20001 16.5999 6.97585 16.5999 10.4ZM15.1253 15.8325C13.8608 16.9334 12.2082 17.6 10.4 17.6C6.4235 17.6 3.19995 14.3765 3.19995 10.4C3.19995 6.42356 6.4235 3.20001 10.4 3.20001C14.3764 3.20001 17.5999 6.42356 17.5999 10.4C17.5999 12.2083 16.9333 13.8609 15.8325 15.1254L20.3535 19.6465C20.5488 19.8417 20.5488 20.1583 20.3535 20.3536C20.1582 20.5488 19.8417 20.5488 19.6464 20.3536L15.1253 15.8325Z"
        fill="currentColor"
      />
    </svg>
  );
}
